import MiniSearch from "minisearch";
import type { 
  EpisodeListItem, 
  EpisodeRecommendations, 
  PopularRecommendation,
  SearchResult
} from "./interfaces";

let miniSearch: MiniSearch | null = null;
let searchData: any[] | null = null;

async function fetchJson(url: string) {
  const res = await fetch(url);
  if (!res.ok) throw new Error(`Failed to fetch ${url}: ${res.status} ${res.statusText}`);
  return res.json();
}

export async function getAllEpisodes(): Promise<EpisodeListItem[]> {
  return fetchJson("/api/episodes.json");
}

export async function getRecommendationsByEpisode(episodeNumber: number): Promise<EpisodeRecommendations> {
  return fetchJson(`/api/episodes/${episodeNumber}/recommendations.json`);
}

export async function getPopularRecommendations(category: string = "All"): Promise<PopularRecommendation[]> {
  return fetchJson(`/api/recommendations/popular-${category}.json`);
}

async function initSearch() {
  if (miniSearch) return;
  
  searchData = await fetchJson("/api/search-index.json");
  miniSearch = new MiniSearch({
    fields: ["title", "body"], // fields to index for full-text search
    storeFields: ["title", "body", "type", "url", "category", "episode_number", "id"], // fields to return with search results
    searchOptions: {
      prefix: true,
      fuzzy: 0.2,
      boost: { title: 2 }
    }
  });
  
  miniSearch.addAll(searchData!);
}

export async function search(query: string, category?: string | null): Promise<SearchResult[]> {
  if (!query) return [];
  await initSearch();

  let results = miniSearch!.search(query);

  if (category && category !== "All") {
    results = results.filter(r => r.category === category);
  }

  return results.slice(0, 25).map(r => ({
    rank: r.score,
    title: r.title,
    body: r.body?.substring(0, 150) + "...", // basic snippet
    type: r.type,
    url: r.url,
    category: r.category,
    episode_number: r.episode_number,
    content_id: r.id
  }));
}
